var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "areaText" }, [
    _c("img", {
      directives: [
        {
          name: "lazy",
          rawName: "v-lazy",
          value: _vm.$config.imgIp + _vm.graphic.logo,
          expression: "$config.imgIp + graphic.logo",
        },
      ],
      staticClass: "img",
      attrs: { align: "right" },
    }),
    _c("div", {
      staticClass: "infos",
      domProps: { innerHTML: _vm._s(_vm.graphic.qyjs) },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }